<template>
  <div>
    <v-card class="d-flex flex-row justify-start" flat>
      <v-col class="px-0" sm="5">
        <v-card flat>
          <h3 class="text-subtitle-1">{{ label }}</h3>
        </v-card>
        <v-card class="d-flex flex-row text-caption" flat>
          <p class="text-caption">{{ tooltip }}</p>
        </v-card>
      </v-col>
      <v-card flat class="grow d-flex">
        <v-text-field
          v-model="peakHours[0]"
          label="Initial Hour"
          hint="24-hour format"
          suffix="hours"
          :min="0"
          :max="23"
          type="number"
          class="mx-2"
        />
        <v-text-field
          v-model="peakHours[1]"
          label="End Hour"
          hint="24-hour format"
          suffix="hours"
          :min="0"
          :max="23"
          type="number"
          class="mx-2"
        />
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "InputServicePeakHours",
  components: {},
  mixins: [],
  props: {
    value: { type: [Array, null], required: true },
    label: { type: String, required: true },
    year_start: { type: Number, required: true },
    num_years: { type: Number, required: true },
    tooltip: { type: String, required: false, default: "tooltip" },
  },
  data() {
    return { peakHours: [] };
  },
  computed: {
    startDay() {
      return DateTime.fromISO(`${this.year_start}-01-01`);
    },
    endDay() {
      return this.startDay.endOf("year").plus({ years: this.num_years - 1 });
    },
    daysArray() {
      const days = [];
      const nDays = this.endDay.diff(this.startDay, "days").days;
      for (let i = 0; i < nDays; i += 1) {
        days.push(
          this.startDay
            .plus({ days: i })
            .toISO({ suppressMilliseconds: true, includeOffset: false })
        );
      }
      return days;
    },
    peakHourArray() {
      if (this.peakHours.length === 2 && this.peakHours.every((v) => v)) {
        return this.daysArray.map((day) => ({
          startDate: DateTime.fromISO(day)
            .set({ hour: this.peakHours[0] })
            .toISO({ suppressMilliseconds: true, includeOffset: false })
            .replace("T", " "),
          endDate: DateTime.fromISO(day)
            .set({ hour: this.peakHours[1] })
            .toISO({ suppressMilliseconds: true, includeOffset: false })
            .replace("T", " "),
        }));
      }
      return [];
    },
  },
  watch: {
    peakHourArray(val) {
      this.$emit("input", val);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    // Get hours if value exists
    if (this.value && this.value.length > 1) {
      this.peakHours = [
        this.getHourFromValueDate(this.value[0].startDate),
        this.getHourFromValueDate(this.value[0].endDate),
      ];
    }
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getHourFromValueDate(valueDate) {
      return DateTime.fromISO(valueDate.replace(" ", "T")).hour;
    },
  },
};
</script>

<style></style>
